import { ColumnSettings, FilterDefinition, FilterOverview } from '@/domain'

export const propertyTypes = new Map([
  ['App\\Models\\WorkLocation', 'Locatie'],
  ['App\\Models\\Client', 'Klant'],
  // ['App\\ClientProduct', 'Klant-product'],
])

const [firstType] = propertyTypes

export const createProperty = () => ({
  name: '',
  type: firstType[0],
  is_multi_selectable: false,
  options: [],
})

export const limits = [10, 25, 50]

export const defaultLimit = 50

const plainColumn = (
  name: string,
  field: string,
  label: string,
  sortable = true,
): ColumnSettings => ({ name, field, label, sortable, type: 'plain' })

export const defaultClientColumns: ColumnSettings[] = [
  plainColumn('client_number', 'client_number', 'generic.clientNumber', false),
  plainColumn('surname', 'surname', 'generic.surname'),
  plainColumn('initials', 'initials', 'generic.initials'),
  plainColumn('specialism', 'specialism', 'generic.specialism'),
  plainColumn('workLocation', 'location', 'generic.location'),
  plainColumn('address', 'address', 'generic.address'),
  plainColumn('zipCode', 'zip_code', 'generic.zipCode'),
  plainColumn('city', 'city', 'generic.city'),
  plainColumn('phoneNumber', 'phone_number', 'generic.phoneNumber'),
  plainColumn('email', 'email', 'generic.emailAddress'),
  {
    name: null,
    field: null,
    label: 'generic.cycles',
    sortable: false,
    type: 'cycles',
  },
]

export const filterDefinitions: Record<FilterOverview, FilterDefinition[]> = {
  clients: [
    { key: 'rep', label: 'generic.rep' },
    { key: 'specialism', label: 'generic.specialism' },
    { key: 'specialism2', label: 'filterSettings.specialism2' },
    { key: 'rayon', label: 'generic.rayon', module: 'rayon' },
    { key: 'brick', label: 'generic.brick' },
    { key: 'product', label: 'generic.product' },
    { key: 'label', label: 'generic.label' },
    { key: 'target', label: 'generic.target', module: 'target' },
    { key: 'optIn', label: 'generic.optIn', module: 'optIn' },
    { key: 'visited', label: 'generic.visited' },
    { key: 'status', label: 'generic.status' },
    { key: 'resultsPerPage', label: 'generic.resultsPerPage' },
  ],
  locations: [
    { key: 'type', label: 'generic.type' },
    { key: 'resultsPerPage', label: 'generic.resultsPerPage' },
    { key: 'label', label: 'generic.label' },
    { key: 'target', label: 'generic.target', module: 'target' },
  ],
  interactions: [
    { key: 'rep', label: 'generic.rep' },
    { key: 'status', label: 'generic.status' },
    { key: 'cycle', label: 'generic.cycle' },
    { key: 'from', label: 'generic.from' },
    { key: 'until', label: 'generic.until' },
    { key: 'rayon', label: 'generic.rayon', module: 'rayon' },
    { key: 'brick', label: 'generic.brick' },
    { key: 'product', label: 'generic.product' },
    { key: 'therapeuticArea', label: 'generic.therapeuticArea' },
    { key: 'label', label: 'generic.label', module: 'target' },
    { key: 'target', label: 'generic.target', module: 'target' },
    { key: 'tier', label: 'generic.tier', module: 'tier' },
    { key: 'rowView', label: 'generic.rowView' },
    { key: 'resultsPerPage', label: 'generic.resultsPerPage' },
  ],
  issuedMaterials: [
    { key: 'rep', label: 'generic.rep' },
    { key: 'cycle', label: 'generic.cycle' },
    { key: 'from', label: 'generic.from' },
    { key: 'until', label: 'generic.until' },
    { key: 'rayon', label: 'generic.rayon', module: 'rayon' },
    { key: 'brick', label: 'generic.brick' },
    { key: 'product', label: 'generic.product' },
    { key: 'label', label: 'generic.label', module: 'target' },
    { key: 'tier', label: 'generic.tier', module: 'tier' },
    { key: 'resultsPerPage', label: 'generic.resultsPerPage' },
  ],
}
